import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-home",
  "use": "foquz-icon-home-usage",
  "viewBox": "0 0 16 18",
  "content": "<symbol viewBox=\"0 0 16 18\" fill=\"none\" id=\"foquz-icon-home\"><path d=\"M6 17v-7h4v7M1 6.6L8 1l7 5.6v8.8c0 .424-.164.831-.456 1.131-.291.3-.687.469-1.1.469H2.556c-.413 0-.809-.169-1.1-.469A1.624 1.624 0 011 15.4V6.6z\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol